import { Form, Spin } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import { searchAPI, setResumeData } from '../../../../../../OnBoarding/actions'
import { SpinWrapper } from '../../../../../../OnBoarding/Register/Education/style'
import {
  AdjustIcon,
  FooterFlex,
  StyledDrawer,
} from '../../DrawerStyle'
import { SubHeading1 } from '../../EducationDetailStyle'
import ProjectForm from '../ProjectForm'
import {
  ButtonLocal,
  Text,
} from '../style'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { searchConfig } from 'utils/config'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { getStudentDataById } from '../../../../../actions'
import instRequest from '../../../../../../../utils/instRequest'
import UpdatePopup  from '../../../UpdatePopup'
import SuccessPopupModal from '../../../SuccessPopup'
const ProjectDrawer = ({
  drawerStatus,
  setdrawerStatus,
  updateStudentData,
  studentFormData,
  pendingData,
  getPendingData,
  instituteName,
  listOfStudentSkills,
  getListOfSkills,
  studentId,
}) => {
  const [form] = Form.useForm()
  const dispatch = new useDispatch()
  const [project, setProject] = useState([])
  const [corporateName, setCorporateName] = useState([])
  const [corporateId, setCorporateId] = useState('')
  const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(true)
  const [skillLoading, setSkillLoading] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [listOfSkills, setListOfSkills] = useState([])
  const [shown, setShown] = useState([])
  const [updated, setUpdated] = useState(false)
  const [tpoConfig, setTpoConfig] = useState(null)
  const [frozenFieldsMap, setFrozenFieldsMap] = useState({})
  const [isAddNewFrozen, setIsAddNewFrozen] = useState(false)
  const [showUpdatePopup, setShowUpdatePopup] = useState(false)
  const [succesPopup, setSuccessPopup] = useState(false)
  const pendingProject = pendingData?.resume?.projects?.length > 0

  useEffect(() => {
    const fetchTpoConfig = async () => {
      try {
        const instituteCampusId = studentFormData?.student?.instituteCampusId
        if (instituteCampusId) {
          const response = await instituteRequest.get(
            `/institutes/${instituteCampusId}/tpo-approval-config`
          )
          if (response?.data?.data) {
            setTpoConfig(response.data.data)
          }
        }
      } catch (error) {
        console.error('Error fetching TPO config:', error)
      }
    }
    fetchTpoConfig()
  }, [studentFormData?.student?.instituteCampusId])

  useEffect(() => {
    if (!tpoConfig || !tpoConfig.tpoApprovalConfig || !tpoConfig.tpoApprovalConfig.fields) {
      setFrozenFieldsMap({})
      setIsAddNewFrozen(false)
      return
    }

    const approvedProjects = studentFormData?.resume?.projects || []
    const frozen = {}
    const fields = tpoConfig.tpoApprovalConfig.fields
    
    const addNewConfig = fields['projects.addNew']
    const hasApprovedProjects = approvedProjects.length > 0
    setIsAddNewFrozen(addNewConfig?.freezeAfterVerification && hasApprovedProjects)

    approvedProjects.forEach((project) => {
      if (!project.id) return

      const projectId = project.id
      frozen[projectId] = {}

      const fieldMappings = {
        'title': 'title',
        'organization': 'organization',
        'started_in': ['startMonth', 'startYear'],
        'ended_in': ['endMonth', 'endYear'], 
        'description': 'description',
        'skill_set': 'skill_set',
        'certifications': 'certifications',
        'function': 'function',
        'role': 'role',
        'industry': 'industry',
        'awards': 'awards'
      }

      Object.entries(fieldMappings).forEach(([uiField, configFields]) => {
        const configFieldArray = Array.isArray(configFields) ? configFields : [configFields]
        
        const shouldFreeze = configFieldArray.some(configField => {
          const fullFieldName = `projects.${configField}`
          const fieldConfig = fields[fullFieldName]
          return fieldConfig && fieldConfig.freezeAfterVerification
        })

        if (shouldFreeze) {
          const fieldValue = project[uiField]
          const hasValue = fieldValue !== null && fieldValue !== undefined && fieldValue !== '' && 
                           (!Array.isArray(fieldValue) || fieldValue.length > 0)

          if (hasValue) {
            frozen[projectId][uiField] = true
          }
        }
      })
    })

    setFrozenFieldsMap(frozen)
  }, [tpoConfig, studentFormData?.resume?.projects])

  useEffect(() => {
    try {
      let projectList = []
      
      const approvedProjects = studentFormData?.resume?.projects || []
      const pendingRequests = pendingData?.requests || []
      
      // Transform API pending data structure
      const projectPendingMap = new Map()
      pendingRequests.forEach(request => {
        if (request.fieldName?.startsWith('projects.') && request.itemId) {
          if (!projectPendingMap.has(request.itemId)) {
            projectPendingMap.set(request.itemId, {})
          }
          const fieldName = request.fieldName.replace('projects.', '')
          //projectPendingMap.get(request.itemId)[fieldName] = {
          // Map 'certifications' to 'certificate' for consistency with form field name
          const mappedFieldName = fieldName === 'certifications' ? 'certificate' : fieldName
          projectPendingMap.get(request.itemId)[mappedFieldName] = {
            value: request.requestedData,
            originalValue: request.originalData,
            status: request.status,
            _requestId: request.id
          }
        }
      })
      
      // Check for new project items
      const newProjectRequests = pendingRequests.filter(request => 
  request.fieldName === 'projects' &&
  request.isNewItem === true &&
  request.status === 'PENDING'
)
      
      const mergedProjects = approvedProjects.map(approvedProj => {
        const pendingFields = projectPendingMap.get(approvedProj.id)
        
        if (pendingFields && Object.keys(pendingFields).length > 0) {
          const merged = { ...approvedProj }
          
          Object.keys(pendingFields).forEach(fieldName => {
            merged[fieldName] = pendingFields[fieldName].value
          })
          
          merged._hasPendingChanges = true
          merged._pendingFields = pendingFields
          
          return merged
        }
        
        return approvedProj
      })
      
      // Handle new pending projects
      const newPendingProjects = []

newProjectRequests.forEach(request => {

  const newProject = {
    ...request.requestedData,
    id: request.itemId,
    _isNew: true,
    _hasPendingChanges: true,
    _pendingFields: {}
  }

  Object.keys(request.requestedData || {}).forEach(fieldName => {

    newProject._pendingFields[fieldName] = {
      value: request.requestedData[fieldName],
      originalValue: null,
      status: request.status,
      _requestId: request.id
    }
  })

  newPendingProjects.push(newProject)
})
      
      const allProjects = [...mergedProjects, ...newPendingProjects]
      
      allProjects.map((data, index) => {
        let formName = 'project_' + index
        const formattedDescription = Array.isArray(data?.description)
          ? data.description.map(item => `${item}`).join('\n')
          : data?.description
        form.setFieldsValue({
          [formName]: {
            id: data?.id,
            temp_id: data?.temp_id,
            corporateId: data?.corporateId,
            organization: data?.organization,
            title: data?.title,
            started_in: data?.started_in,
            ended_in: data?.ended_in,
            function: data?.function,
            role: data?.role,
            industry: data?.industry,
            description: formattedDescription,
            skill_set: data?.skill_set,
            certificate: data?.certificate,
            awards: data?.awards,
            isDelete: false,
            shown: true,
          },
        })
        return projectList.push({
          component: ProjectForm,
          formName: formName,
        })
      })
      setProject(projectList)
    } catch (error) {
      console.error('Error in ProjectDrawer useEffect:', error)
      setProject([])
    }
  }, [studentFormData, pendingData])

  const projectHandler = (isAdd, isDelete, deleteForm) => {
    const experienceKeys = Object.keys(form.getFieldValue())

    let lastValue = 0
    for (let i = experienceKeys.length - 1; i >= 0; i--) {
      const key = experienceKeys[i]
      const intValue = parseInt(key.split('_')[1])
      if (!isNaN(intValue)) {
        lastValue = intValue
        break
      }
    }
    let arr = []
    let formName = 'project_' + `${lastValue + 1}`
    arr.push({
      component: ProjectForm,
      formName: formName,
    })
    if (isAdd) {
      setIsUpdateButtonEnabled(false)
      return setProject([...project, ...arr])
    }
    if (isDelete) {
      form.setFieldValue([[deleteForm], 'isDelete'], true)
      setIsUpdateButtonEnabled(false)
      let updatedList = project?.filter(data => data?.formName !== deleteForm)
      return setProject(updatedList)
    }
  }
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  const submitHandler = async () => {
    if (submitLoading) {
      return
    }
    
    setSubmitLoading(true)
    
    try {
      let project = []
      let internship = []
      const values = await form.getFieldValue()
      const errorList = []
      await form
        .validateFields()
        .then()
        .catch(err => {
          errorList.push(err?.errorFields)
        })
      if (!errorList?.length) {
      Object.entries(values).forEach(([name, obj]) => {
        if (
          name.includes('project') &&
          !name.includes('award') &&
          !obj?.isDelete
        ) {
          project.push({
            ...obj,
            awards: [],
          })
        } else if (
          name.includes('internship') &&
          !name.includes('award') &&
          !obj?.isDelete
        ) {
          internship.push({
            ...obj,
            awards: [],
          })
        }
      })

      let awardProjectData = []
      Object.entries(project).forEach((data, index) => {
        Object.entries(values).forEach(([name, obj]) => {
          if (name.includes('project_' + index + 'award')) {
            let load = {
              [index]: obj,
            }
            awardProjectData.push(load)
          }
        })
      })

      for (let i = 0; i < project.length; i++) {
        for (const [key, value] of Object.entries(awardProjectData)) {
          for (const [key1, value1] of Object.entries(value)) {
            if (key1 == i) {
              project[i].awards.push(value1)
            }
          }
        }
      }

      project = project.map(proj => ({
        ...proj,
        skill_set: proj.skill_set
          ? proj.skill_set.map(skill => ({
              id: uuidRegex.test(skill.id) ? skill.id : '',
              name: skill.name,
            }))
          : [],
      }))

      const uniqueProjects = []
      const seenIds = new Set()
      const seenKeys = new Set()
      
      project.forEach(proj => {
        if (proj.id && !proj.id.startsWith('temp-')) {
          if (seenIds.has(proj.id)) {
            return
          }
          seenIds.add(proj.id)
          uniqueProjects.push(proj)
        } else {
          const key = JSON.stringify({
            title: proj.title,
            organization: proj.organization,
            started_in: proj.started_in,
            ended_in: proj.ended_in
          })
          if (!seenKeys.has(key)) {
            seenKeys.add(key)
            uniqueProjects.push(proj)
          }
        }
      })

      // Track new projects for frontend pending state
      const existingProjectIds = new Set((studentFormData?.resume?.projects || []).map(proj => proj.id))
      
      project.forEach((proj, index) => {
        // If this is a new item (no ID or not in existing items), mark as new without temp ID
        if (!proj.id || !existingProjectIds.has(proj.id)) {
          proj._isNew = true
        }
      })

      let payload = {
        refreshRanking: true,
        isDirectTPOUpdate: true,
        checkDeleteSection: ['projects'],
        admin: {
          ...studentFormData?.admin,
          countryCode: studentFormData?.admin?.countryCode,
        },
        student: studentFormData?.student ? {
          ...studentFormData?.student,
          id: studentId,
          instituteCampusId: studentFormData?.student?.instituteCampusId || studentFormData?.admin?.institute_campus_id,
        } : { 
          id: studentId,
          instituteCampusId: studentFormData?.admin?.institute_campus_id,
        },
        degreeStreamMap: !studentFormData?.student?.isExpCandidate
          ? {
              degreeId: studentFormData?.currentCourse?.degreeId,
              streamId: studentFormData?.currentCourse?.streamId,
            }
          : {},
        studentPersonalProfile: studentFormData?.studentPersonalProfile,
        currentCourse: !studentFormData?.student?.isExpCandidate
          ? {
              ...studentFormData?.currentCourse,
              marks: studentFormData?.currentCourse?.marks ?? 0,
            }
          : {},
        education: studentFormData?.education,
        resume: {
          ...studentFormData?.resume,
          projects: uniqueProjects,
        },
      }
      if (payload?.currentCourse?.specialisationId === null) {
        delete payload?.currentCourse?.specialisationId
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === null) {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === '') {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      if (payload?.studentPersonalProfile?.registraionNo) {
        delete payload?.studentPersonalProfile?.registraionNo
      }
      studentFormData?.education?.map((item, index) => {
        if (item?.skills === null) delete payload?.education?.[index]?.skills
        if (item?.degreeStreamMapId === null)
          delete payload?.education?.[index]?.degreeStreamMapId
      })
      uniqueProjects.map((item, index) => {
        if (
          item?.certificate == null ||
          Object.keys(item?.certificate)?.length === 0
        ) {
          delete uniqueProjects[index]?.certificate
        }

        delete uniqueProjects[index]?.startMonth
        delete uniqueProjects[index]?.startYear
        delete uniqueProjects[index]?.endMonth
        delete uniqueProjects[index]?.endYear
      })
      if (payload?.currentCourse?.skills === null) {
        delete payload?.currentCourse?.skills
      }
      if (payload?.currentCourse?.degreeStreamMapId === null) {
        delete payload?.currentCourse?.degreeStreamMapId
      }
      const response = await updateStudentData(payload);
      await dispatch(setResumeData(payload))
      
      dispatch(getStudentDataById(studentId)).catch(err => console.error('getStudentData error:', err))
      getPendingData().catch(err => console.error('getPendingData error:', err))
      
      setSubmitLoading(false)
      
      if (response?.success === true) {
        SuccessMessage('Project sent for Approval!')
        setdrawerStatus(false)
        setUpdated(true)
      } else {
        ErrorMessage(response?.response?.data?.message)
      }
    } else {
      const errorForms = []

      errorList.map(item => {
        item.map(innerItem => {
          if (!errorForms.includes(innerItem?.name[0][0])) {
            errorForms.push(innerItem?.name[0][0])
          }
        })
      })
      const updatedValues = {}
      Object.keys(values).forEach(key => {
        if (errorForms.includes(key)) {
          updatedValues[key] = {
            ...values[key],
            shown: true,
          }
        } else {
          updatedValues[key] = {
            ...values[key],
          }
        }
      })

      form.setFieldsValue(updatedValues)
      setShown(errorForms)
      setSubmitLoading(false)
    }
    } catch (error) {
      console.error('Error in submitHandler:', error)
      ErrorMessage('An error occurred while submitting. Please try again.')
      setSubmitLoading(false)
    }
  }

  const [listOfAddedSkills, setListOfAddedSkills] = useState([])
  const SkillsAPI = async (page, search) => {
    try {
      const results = await dispatch(
        searchAPI(searchConfig?.skills?.name, search, searchConfig?.skills)
      )
      let v = {
        name: search,
        id: Math.random().toString(36).substr(2, 8),
      }

      let updatedSkills = results || []
      if (updatedSkills?.length === 0 && search) {
        setListOfAddedSkills([...listOfAddedSkills, v])
        setListOfSkills([...updatedSkills, v])
      }
      const isExactMatch = updatedSkills?.some(
        skill => skill?.name.toLowerCase() === search?.toLowerCase()
      )
      if (updatedSkills?.length > 0) {
        if (!isExactMatch && search?.length > 3) {
          setListOfAddedSkills([...listOfAddedSkills, v])
          setListOfSkills([...updatedSkills, v])
        } else {
          setListOfSkills(updatedSkills)
        }
      }
    } catch (error) {
      console.error(`Error searching ${searchConfig?.skills?.name}:`, error)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setSkillLoading(true)
        
        const timeoutPromise = new Promise((_, reject) => 
          setTimeout(() => reject(new Error('SkillsAPI timeout')), 5000)
        )
        
        await Promise.race([SkillsAPI(0), timeoutPromise])
      } catch (error) {
        console.error('SkillsAPI error:', error)
      } finally {
        setSkillLoading(false)
      }
    }

    fetchData()
  }, [])

  const content = () => {
    return (
      <>
        <Form
          scrollToFirstError
          onFinish={submitHandler}
          id={'projectForm'}
          form={form}
          layout="vertical"
        >
          {!!project?.length &&
            project?.map((obj, index) => {
              const approvedProjects = studentFormData?.resume?.projects || []
              const pendingRequests = pendingData?.requests || []
              
              // Transform API pending data structure
              const projectPendingMap = new Map()
              pendingRequests.forEach(request => {
                if (request.fieldName?.startsWith('projects.') && request.itemId) {
                  if (!projectPendingMap.has(request.itemId)) {
                    projectPendingMap.set(request.itemId, {})
                  }
                  const fieldName = request.fieldName.replace('projects.', '')
                  //  projectPendingMap.get(request.itemId)[fieldName] = {
                  //  Map 'certifications' to 'certificate' for consistency with form field name
                  const mappedFieldName = fieldName === 'certifications' ? 'certificate' : fieldName
                  projectPendingMap.get(request.itemId)[mappedFieldName] = {
                    value: request.requestedData,
                    originalValue: request.originalData,
                    status: request.status,
                    _requestId: request.id
                  }
                }
              })
              
              const newProjectRequests = pendingRequests.filter(request => 
  request.fieldName === 'projects' &&
  request.isNewItem === true &&
  request.status === 'PENDING'
)
              
              const mergedProjects = approvedProjects.map(approvedProj => {
                const pendingFields = projectPendingMap.get(approvedProj.id)
                
                if (pendingFields && Object.keys(pendingFields).length > 0) {
                  const merged = { ...approvedProj }
                  Object.keys(pendingFields).forEach(fieldName => {
                    merged[fieldName] = pendingFields[fieldName].value
                  })
                  merged._hasPendingChanges = true
                  merged._pendingFields = pendingFields
                  return merged
                }
                return approvedProj
              })
              
              const newPendingProjects = []

newProjectRequests.forEach(request => {

  const newProject = {
    ...request.requestedData,
    id: request.itemId,
    _isNew: true,
    _hasPendingChanges: true,
    _pendingFields: {}
  }

  Object.keys(request.requestedData || {}).forEach(fieldName => {

    newProject._pendingFields[fieldName] = {
      value: request.requestedData[fieldName],
      originalValue: null,
      status: request.status,
      _requestId: request.id
    }
  })

  newPendingProjects.push(newProject)
})
              
              const allProjects = [...mergedProjects, ...newPendingProjects]
              const currentProject = allProjects[index]
              const projectId = currentProject?.id
              const frozenFields = projectId ? frozenFieldsMap[projectId] || {} : {}
              
              return (
                <obj.component
                  key={index + 'project'}
                  form={form}
                  onRemove={projectHandler}
                  formName={obj?.formName}
                  studentFormData={studentFormData}
                  listOfStudentSkills={listOfStudentSkills}
                  getListOfSkills={getListOfSkills}
                  setCorporateName={setCorporateName}
                  corporateName={corporateName}
                  setCorporateId={setCorporateId}
                  corporateId={corporateId}
                  setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                  skillLoading={skillLoading}
                  setSkillLoading={setSkillLoading}
                  listOfSkills={listOfSkills}
                  SkillsAPI={SkillsAPI}
                  shown={shown}
                  frozenFields={frozenFields}
                  pendingFields={currentProject?._pendingFields || {}}
                  isNew={currentProject?._isNew || false}
                />
              )
            })}
        </Form>
        <SubHeading1>Note:</SubHeading1>
        <SubHeading1>
          Please fill in all details in the section below to ensure exposure to
          maximum number of corporates
        </SubHeading1>
        <ButtonLocal 
          onClick={() => !isAddNewFrozen && projectHandler(true, false, null)}
          disabled={isAddNewFrozen}
          style={{ 
            opacity: isAddNewFrozen ? 0.5 : 1, 
            cursor: isAddNewFrozen ? 'not-allowed' : 'pointer' 
          }}
        >
          <Control alignCenter gap="10px">
            <AdjustIcon>
              <AddIcon />
            </AdjustIcon>
            <Text>Add Project</Text>
          </Control>
        </ButtonLocal>
        {studentFormData?.resume?.projects?.length > 0 && skillLoading && (
          <SpinWrapper center>
            <Spin />
          </SpinWrapper>
        )}
      </>
    )
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setdrawerStatus(false)
          }}
        />
        <Button.Primary          
          onClick={async () => {
            try {
              await form.validateFields()
              if(!pendingProject) {                
                form.submit()
              }
              else {
                setShowUpdatePopup(true)
              }
            } catch (err) {
            }
          }}
          text={'Update'}
          disabled={isUpdateButtonEnabled || submitLoading}
          loading={submitLoading}
        />
      </FooterFlex>
    )
  }

  return (
    <>
      <UpdatePopup
    open={showUpdatePopup}
    form={'projectForm'}
    htmltype="submit"
    loading={submitLoading}
    onCancel={() => setShowUpdatePopup(false)}
    onConfirm={() => {
      setShowUpdatePopup(false)
      setSuccessPopup(true)
      form.submit()  
    }}
  />
  <SuccessPopupModal
    open={succesPopup}
    onClose={() => setSuccessPopup(false)}
  />
    <StyledDrawer
      width="675px"
      title={'Project Detail'}
      placement="right"
      closable={true}
      onClose={() => setdrawerStatus(false)}
      visible={drawerStatus}
      content={content()}
      footer={footer()}
    />
    </>
  )
}

export default ProjectDrawer
